var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-91d4eb42-446b-4489-a080-40950d5c3f80",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56.73 69.44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .uuid-05780ec7-a69a-4b82-8df4-226dc7b6838a {\n        fill: none;\n        stroke: #2B3983;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 8px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "uuid-05780ec7-a69a-4b82-8df4-226dc7b6838a",
    d: "M8.3,4c5.93,5.09,12.26,10.27,19.01,15.46,8.72,6.71,17.23,12.76,25.42,18.22-3.87,2.61-15.47,10.36-27.33,16.95-6.01,3.34-11.78,6.22-11.78,6.22-3.7,1.85-6.96,3.38-9.62,4.58"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightIcon);
export default __webpack_public_path__ + "static/media/right-icon.e86c2994a4d3d5b16e05dcb64a59a13d.svg";
export { ForwardRef as ReactComponent };